import api from './api';
import { Offer, ApiResponse } from '../types';

const mockOffers: Offer[] = [
  {
    id: '1',
    title: 'Early Bird Special',
    description: 'Book 3 months in advance and save 25% on your retreat.',
    discount: 25,
    validFrom: '2024-01-01T00:00:00Z',
    validTo: '2024-06-30T23:59:59Z',
    image: 'https://via.placeholder.com/400x300',
    isActive: true,
    retreatIds: ['1', '2'],
  },
  {
    id: '2',
    title: 'Summer Special',
    description: 'Enjoy 15% off on all summer retreats.',
    discount: 15,
    validFrom: '2024-05-01T00:00:00Z',
    validTo: '2024-08-31T23:59:59Z',
    image: 'https://via.placeholder.com/400x300',
    isActive: true,
  },
  {
    id: '3',
    title: 'First-Time Visitor',
    description: 'New to retreats? Get 20% off your first booking.',
    discount: 20,
    validFrom: '2024-01-01T00:00:00Z',
    validTo: '2024-12-31T23:59:59Z',
    image: 'https://via.placeholder.com/400x300',
    isActive: true,
  },
];

export const offerService = {
  async getOffers(): Promise<ApiResponse<Offer[]>> {
    // Mock implementation - replace with actual API call when backend is ready
    return new Promise((resolve) => {
      setTimeout(() => {
        const activeOffers = mockOffers.filter(offer => offer.isActive);
        resolve({
          data: activeOffers,
          message: 'Offers fetched successfully',
          success: true,
        });
      }, 700);
    });
    
    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get('/offers');
    // return response.data;
  },

  async getOfferById(id: string): Promise<ApiResponse<Offer>> {
    // Mock implementation
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const offer = mockOffers.find(o => o.id === id);
        if (offer) {
          resolve({
            data: offer,
            message: 'Offer fetched successfully',
            success: true,
          });
        } else {
          reject(new Error('Offer not found'));
        }
      }, 500);
    });
    
    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get(`/offers/${id}`);
    // return response.data;
  },

  async getActiveOffers(): Promise<ApiResponse<Offer[]>> {
    // Mock implementation
    return new Promise((resolve) => {
      setTimeout(() => {
        const currentDate = new Date();
        const activeOffers = mockOffers.filter(offer => {
          const validFrom = new Date(offer.validFrom);
          const validTo = new Date(offer.validTo);
          return offer.isActive && currentDate >= validFrom && currentDate <= validTo;
        });
        resolve({
          data: activeOffers,
          message: 'Active offers fetched successfully',
          success: true,
        });
      }, 600);
    });
    
    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get('/offers/active');
    // return response.data;
  },
};
